import styled from 'styled-components'
// @ts-ignore
import { sys, ref } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'

export const NO_AUTHORS_FOUND_LIGHT = ref.color.gray[400]
export const NO_AUTHORS_FOUND_DARK = ref.color.gray[1100]
export const SIMPLE_BAR_PROGRESS_LIGHT = ref.color.gray[800]
export const SIMPLE_BAR_PROGRESS_DARK = ref.color.gray[600]

export const StyledTableContainer = styled.div`
  margin: 0 -16px;

  tbody,
  tr,
  th,
  td {
    background-color: ${({ theme }: { theme: Theme }) =>
      theme === 'light' ? ref.color.gray[200] : 'transparent'};
  }
`

export const StyledAuthorInfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding-left: 8px;
`

export const StyledSimpleBarContainer = styled.div`
  width: 100%;
  padding-right: 8px;
`

export const StyledLeftHeaderContainer = styled.div`
  padding: 8px 0 8px 8px;
`

export const StyledRightHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  // to override the default style on parent th element
  padding: 8px 0 8px -12px;
  position: absolute;
  top: 8px;
  left: 0;
  gap: 2px;
`

export const StyledIconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.placeholder};
`

export const StyledHeader = styled.div`
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.placeholder};
  width: 100%;
  display: flex;
  padding: 8px 0;
  border-bottom: 1px solid ${({ mode }: { mode: Theme }) => sys[mode].common.divider[100]};
`

export const StyledLeft = styled.div`
  flex: 1;
  padding-left: 16px;
`

export const StyledRight = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  // to remove the default style 'padding-right: 8px' and 'padding-left: 12px' of table header
  margin-left: -12px;
  padding-right: 8px;
`

export const StyledBody = styled.div`
  width: 100%;
`

export const StyledNoDataContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 104px;
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.placeholder};
  border-bottom: 1px solid ${({ mode }: { mode: Theme }) => sys[mode].common.divider[100]};
`
